import { motion, useReducedMotion } from "motion/react"

import styles from "./index.module.scss"

const COMPASS_IDLE_DURATION = 8.4
const COMPASS_ROTATE_DURATION = 2
const COMPASS_CYCLE_DURATION = COMPASS_IDLE_DURATION + COMPASS_ROTATE_DURATION
const COMPASS_ROTATE_START = COMPASS_IDLE_DURATION / COMPASS_CYCLE_DURATION
const COMPASS_ROTATE_END = 1

const easeInOutElastic = (value: number) => {
    if (value === 0 || value === 1) {
        return value
    }

    const c5 = (2 * Math.PI) / 4.5

    return value < 0.5
        ? -(2 ** (20 * value - 10) * Math.sin((20 * value - 11.125) * c5)) / 2
        : (2 ** (-20 * value + 10) * Math.sin((20 * value - 11.125) * c5)) / 2 +
              1
}

const LoadingTitle = () => {
    const shouldReduceMotion = useReducedMotion() ?? false

    return (
        <div className={styles.title}>
            <div className={styles.footprints}>
                <motion.div
                    className={styles.compass}
                    animate={
                        shouldReduceMotion
                            ? { rotate: 0 }
                            : { rotate: [0, 0, 360] }
                    }
                    transition={
                        shouldReduceMotion
                            ? undefined
                            : {
                                  duration: COMPASS_CYCLE_DURATION,
                                  ease: ["linear", easeInOutElastic],
                                  repeat: Infinity,
                                  times: [
                                      0,
                                      COMPASS_ROTATE_START,
                                      COMPASS_ROTATE_END,
                                  ],
                              }
                    }
                />
                <div className={styles.flag} />
                <div className={styles.text}>
                    <div className={styles.textInner} />
                </div>
            </div>
        </div>
    )
}

export default LoadingTitle
